import styled from 'styled-components';
import { colors, colorAliases } from '../../../../variables/colors.js';
import { deviceWidths } from '../../../../variables/widths.js';

var dimensions = {
  cardMinHeight: '340px',
  cardMinHeightMobile: '152px'
};
var HotelHitContainer = styled.div.withConfig({
  displayName: "hotelHit__HotelHitContainer",
  componentId: "sc-34pkjx-0"
})(["background:", ";box-shadow:0 0 1px ", ";display:flex;min-height:", ";position:relative;overflow:hidden;@media (min-width:", "){min-height:", ";}"], colors.white, colorAliases.shadow, dimensions.cardMinHeightMobile, deviceWidths.tablet, dimensions.cardMinHeight);
var HotelHitTabletLink = styled.a.withConfig({
  displayName: "hotelHit__HotelHitTabletLink",
  componentId: "sc-34pkjx-1"
})(["@media (max-width:", "){position:absolute;width:100%;height:100%;top:0;left:0;text-decoration:none;z-index:10;}"], deviceWidths.tabletMax);

export { HotelHitContainer, HotelHitTabletLink };
//# sourceMappingURL=hotelHit.js.map
